import { LineSheetFile } from "@/features/line-sheet-sets/line-sheet-file-controller";
import AppSelect from "@/features/line-sheet-sets/app-select";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { useMemo } from "react";
import { StoredObject } from "@/features/types";
import { toLower } from "@/utils/case";

interface LineSheetFileTypeSelectProps {
  value?: LineSheetFile["type"];
  isExcel: boolean;
  isPdf?: boolean;
  onSelect: (value: LineSheetFile["type"]) => void;
  isDisabled?: boolean;
}

export default function LineSheetFileTypeSelect({
  value,
  isExcel,
  isPdf,
  onSelect,
  isDisabled,
}: LineSheetFileTypeSelectProps) {
  const { tTitle } = useI18nHelper();

  const options = useMemo(() => {
    return (() => {
      if (isExcel) {
        return ["LINE_SHEET", "ORDER_FORM", "ATTACHMENT", "ORDER_RULE"];
      } else if (isPdf) {
        return ["LINE_SHEET", "ATTACHMENT", "ORDER_RULE"];
      } else {
        return ["ATTACHMENT", "ORDER_RULE"];
      }
    })().map((type) => {
      return {
        name: tTitle(toLower(type)),
        value: type,
      };
    });
  }, [isExcel, isPdf, tTitle]);

  return (
    <AppSelect
      width={"100%"}
      name={tTitle("type")}
      options={options}
      value={value}
      isDisabled={isDisabled}
      onSelect={(value) => {
        onSelect(value as LineSheetFile["type"]);
      }}
    />
  );
}
